import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Button from '../common/Button';
import WrapperSecondary from '../common/WrapperSecondary';
import i18n from '../core/i18n';

class Screen extends React.Component {
  componentDidMount() {
    const { lang, teamName } = this.props;

    if (lang) {
      i18n.changeLanguage(lang);
      document.title = i18n.t('docTitle', { name: teamName });
    }
  }

  handleSubmit = () => {
    const { inviteId } = this.props.match.params;
    const { history } = this.props;

    history.push(`/invite/${inviteId}/accept`);
  };

  render() {
    const { t, onboardingHtml } = this.props;

    return (
      <WrapperSecondary
        title={t('invite.title')}
        subtitle={t('invite.subtitle')}
      >
        <React.Fragment>
          <div dangerouslySetInnerHTML={{ __html: onboardingHtml }} />
          <div className="u-text-center u-margin-top-large">
            <Button onClick={this.handleSubmit}>
              {t('invite.continueBtn')}
            </Button>
          </div>
        </React.Fragment>
      </WrapperSecondary>
    );
  }
}

const mapStateToProps = ({ workspace }) => ({
  onboardingHtml: workspace.data.onboardingHtml,
  lang: workspace.data && workspace.data.lang,
  teamName: workspace.data && workspace.data.name,
});

export default connect(mapStateToProps)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/invite/Screen.js